import { render, staticRenderFns } from "./PendingMentorshipRequests.vue?vue&type=template&id=ffc65f60&scoped=true&"
import script from "./PendingMentorshipRequests.vue?vue&type=script&lang=js&"
export * from "./PendingMentorshipRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc65f60",
  null
  
)

export default component.exports